import { IndividualPlaceInput } from '../../lib/types/models/trip-booking/trip-date'
import { DispatchIndividualInput } from '../../lib/types/models/trip-booking/trip-date-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type DispatchIndividualsRequest = DispatchIndividualInput & {
  data: IndividualPlaceInput[]
}

export function dispatch({ id, ...data }: IdInput<DispatchIndividualsRequest>) {
  return restApiClient
    .url(constructApiUrl(API.tripDates.dispatch.url, { id }))
    .post<never, DispatchIndividualsRequest>(data)
}
